import api from './api';

export const balanceService = {
  async getBalances() {
    return api.get('/balance/me');
  }
}; 